module.exports = function(bootstrap) {
    bootstrap.run(["Service", "$q", "brand", "brandConfig", "session", "sessionData", "$cookies", "$http",
                      function (Service, $q, brand, brandConfig, session, sessionData, $cookies, $httpProvider) {

                          new Service({
                                          name: 'alerts',
                                          group:"eprsvc",
                                          url:"/eprsvc/x-services/secure/documents/v1/alerts/count",
                                          headers: {},
                                          submitSearch: function() {
                                              this.headers['APPID'] = "EPRWEB";
                                              this.headers['FromDP'] = sessionData.basicInfo.loginId;
                                              this.headers['clientHost'] = "hmhs.com";
                                              return this.get();
                                          }
                                      });
                      }]);
};